var _rect, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star_2",
    d: "M11.1033 2.81699C11.4701 2.07374 12.5299 2.07374 12.8967 2.81699L15.0736 7.22784C15.2193 7.52298 15.5008 7.72755 15.8266 7.77488L20.6942 8.48219C21.5144 8.60138 21.842 9.60935 21.2484 10.1879L17.7262 13.6213C17.4905 13.851 17.3829 14.182 17.4386 14.5064L18.2701 19.3544C18.4102 20.1713 17.5527 20.7942 16.8191 20.4086L12.4653 18.1196C12.174 17.9665 11.826 17.9665 11.5347 18.1196L7.18089 20.4086C6.44726 20.7942 5.58983 20.1713 5.72994 19.3544L6.56143 14.5064C6.61707 14.182 6.50952 13.851 6.27384 13.6213L2.75156 10.1879C2.15805 9.60935 2.48556 8.60138 3.30578 8.48219L8.17344 7.77488C8.49915 7.72755 8.78072 7.52298 8.92638 7.22784L11.1033 2.81699Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_670_8941",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 19
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Star_3",
    d: "M11.1033 2.81699C11.4701 2.07374 12.5299 2.07374 12.8967 2.81699L15.0736 7.22784C15.2193 7.52298 15.5008 7.72755 15.8266 7.77488L20.6942 8.48219C21.5144 8.60138 21.842 9.60935 21.2484 10.1879L17.7262 13.6213C17.4905 13.851 17.3829 14.182 17.4386 14.5064L18.2701 19.3544C18.4102 20.1713 17.5527 20.7942 16.8191 20.4086L12.4653 18.1196C12.174 17.9665 11.826 17.9665 11.5347 18.1196L7.18089 20.4086C6.44726 20.7942 5.58983 20.1713 5.72994 19.3544L6.56143 14.5064C6.61707 14.182 6.50952 13.851 6.27384 13.6213L2.75156 10.1879C2.15805 9.60935 2.48556 8.60138 3.30578 8.48219L8.17344 7.77488C8.49915 7.72755 8.78072 7.52298 8.92638 7.22784L11.1033 2.81699Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_670_8941)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Fill",
    x: 0.75,
    y: 1,
    width: 11.25,
    height: 22,
    fill: "#F4A403"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStarIcon);
export default __webpack_public_path__ + "static/media/halfStarIcon.5ae9dc0fae0456adc5fdd8255eb3c61d.svg";
export { ForwardRef as ReactComponent };